import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import "./features.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../layout";
import { cmsInstance } from "../../axios/axiosconfig";
import FeatureBox from "./FetureBox";
import EmptyRow from "../common/EmptyRow";

function Features() {
  const { i18n } = useTranslation();
  const [pageContent, setPageContent] = useState({});

  const getContent = async () => {
    try {
      const page = window.location.pathname.replace("/cms/", "");
      const { language } = i18n;
      const {
        data: { content, msg },
        status,
      } = await cmsInstance.get(`/content${page}/${language}`);
      if (status === 200) {
        setPageContent(content);
      } else {
        NotificationManager.error(msg, "Message", 10000);
      }
    } catch (error) {
      console.error("Error", error.message);
    }
  };
  const onLanguageChanged = () => {
    getContent();
  };

  useEffect(() => {
    getContent();
    i18n.on("languageChanged", onLanguageChanged);
  }, []);

  return (
    <Layout>
      <div className="features-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title-page">
                <ul className="breadcrum">
                  <li>
                    <Link to="/">{pageContent.home}</Link>
                  </li>
                  <li>{pageContent.features}</li>
                </ul>
                <h2>{pageContent.features}</h2>

                <p>{pageContent.heading1}</p>
              </div>
            </div>
          </div>

          <div className="row">
            <FeatureBox
              header={pageContent.heading2}
              paragraph={pageContent.para1}
            />
            <EmptyRow />
            <FeatureBox
              header={pageContent.para2}
              paragraph={pageContent.para6}
            />
            <FeatureBox
              header={pageContent.para3}
              paragraph={pageContent.para7}
            />
            <EmptyRow />
            <FeatureBox
              header={pageContent.para4}
              paragraph={pageContent.para8}
            />
            <FeatureBox
              header={pageContent.para5}
              paragraph={pageContent.para9}
            />
            <EmptyRow />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Features;
